import type { SourceReference } from '@shared/contract';
import { formatDuration } from '../lib/format';

export function References({ refs, onJump }: { refs: SourceReference[]; onJump: (ref: SourceReference) => void }) {
  if (!refs.length) return null;
  return (
    <span className="refs">
      {refs.map((r) => (
        <button key={r.transcript_segment_id} className="ref" title={r.quote} onClick={() => onJump(r)}>
          {formatDuration(r.start_ms)}
        </button>
      ))}
    </span>
  );
}
